import React from 'react';
import * as _ from './style';

const Loading = () => {
  return (
    <_.Loading_Animation>
      <_.Loading_Dot />
      <_.Loading_Dot />
      <_.Loading_Dot />
    </_.Loading_Animation>
  );
};

export default Loading;
